import { z } from 'zod';

export const dependencyStatusSchema = z.enum(['ok', 'unreachable']);
export type DependencyStatus = z.infer<typeof dependencyStatusSchema>;

/**
 * Shape of `GET /api/health`. The frontend parses the response with this schema
 * rather than trusting its own types, so a server-side change to the contract
 * surfaces as a parse failure instead of silently rendering `undefined`.
 */
export const healthSchema = z.object({
  status: z.enum(['ok', 'degraded']),
  version: z.string().min(1),
  database: dependencyStatusSchema,
});
export type Health = z.infer<typeof healthSchema>;
